import { action, computed, observable } from 'mobx';
import UserApi from 'api/user';
import rootStore from 'store/rootStore';

class UserStore {
    @observable id;
    @observable loading = true;
    @observable email;
    @observable roles;
    @observable.shallow activeSubscription;

    @computed get hasFamily() {
        return !!this.rootStore.family;
    }

    @computed get hasFamilyTier() {
        if (!this.activeSubscription) {
            return false;
        }

        return this.activeSubscription.familyTier;
    }

    @computed get familyMemberActions() {
        return this.hasFamily && this.hasFamilyTier;
    }

    @computed get familyOwnerActions() {
        return this.familyMemberActions && this.rootStore.family.isOwner;
    }

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @action
    requestUserMe() {
        this.loading = true;

        const q = UserApi.getMe();

        q.then(response => {
            this.setUser(response.data);
        });

        return q;
    }

    @action.bound
    setUser(user) {
        this.id = user.id;
        this.email = user.email;
        this.roles = user.roles;
        this.activeSubscription = user.activeSubscription;

        if (user.family && !rootStore.family.id) {
            rootStore.family.setFamily(user.family);
        }

        this.loading = false;
    }
}

export default UserStore;


// WEBPACK FOOTER //
// ./src/store/user.js